module.exports = __webpack_public_path__ + "static/media/calendar-primary.45bc9a0c.svg";